import React from 'react'
import avatar404 from '../../../assets/img/errors/404/Illustration.svg'
import error404 from '../../../assets/img/errors/404/404.svg'
import { Row, Col } from 'react-bootstrap'

const Error404: React.FC = () => {
  return (
    <div className="d-flex min-vh-100 align-items-center justify-content-center">
      <Row>
        <Col>
          <div>
            <img src={error404} />
          </div>
          <div className="fw-bold fs-6 my-2">Aqui no hay pista... aún</div>
          <div className="mb-2">
            Busca por ciudad, categoría o proveedor y <br /> arma tu evento.
          </div>
          <a href="/" className="btn btn-primary">
            Volver al inicio
          </a>
        </Col>

        <Col>
          <div className="container text-center">
            <img src={avatar404} />
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default Error404
